/**
 * ChartLegendContainer - Logic and state management for chart legend
 *
 * Manages legend display for chart status indicators.
 * @remarks This is a Container component - contains logic and state
 */

import { memo } from "react";

import ChartLegendView from "./ChartLegendView";

/**
 * Props for ChartLegendContainer component
 */
interface ChartLegendProps {
  readonly isDark: boolean;
}

/**
 * ChartLegendContainer manages chart legend display
 * @param props - Container props
 * @returns ChartLegendView component
 */
const ChartLegendContainer = memo(({ isDark }: ChartLegendProps) => (
  <ChartLegendView isDark={isDark} />
));

ChartLegendContainer.displayName = "ChartLegendContainer";

export default ChartLegendContainer;
